import { MenuItem, SelectChangeEvent, Box } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import { FACT_TYPES } from "./Constants";
import Select from "components/common/Select";

interface Props {
  selectedCategory: string;
  onChange: (category: string) => void;
  error?: string | null;
  disabled?: boolean;
}

export default ({ selectedCategory, onChange, error, disabled }: Props) => {
  const handleChange = (event: SelectChangeEvent) => {
    const selectedValue = event.target.value;
    onChange(selectedValue);
  };

  return (
    <Select
      variant="outlined"
      label="Category"
      sx={{
        width: "100%",
        ".MuiSelect-select": {
          ...(selectedCategory
            ? {
                paddingTop: "13px",
                paddingBottom: "13px",
              }
            : null),
        },
      }}
      disabled={disabled}
      error={!!error}
      value={selectedCategory}
      renderValue={(value) => {
        const obj = FACT_TYPES.find((cat) => cat.value === value);
        return obj ? <Box>{obj.label}</Box> : null;
      }}
      onChange={handleChange}
    >
      {FACT_TYPES.map((cat) => (
        <MenuItem sx={{ margin: "0px" }} key={cat.value} value={cat.value}>
          <ListItem component="div" disablePadding>
            {cat.label}
          </ListItem>
        </MenuItem>
      ))}
    </Select>
  );
};
